import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Steady Dev - TIL`}</p>
    {/* ![Logo](https://via.placeholder.com/215x40?text=Document) */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      